import Helpers from "../helpers";

export default class Posts {
  show() {
    var helpers = new Helpers()
    // set carousel items same height
    helpers.sameHeight('.row-related-posts .post-mini')
  }
}
